"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealHealthyLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealHealthyLinear = function MealHealthyLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.035 10.227l-.001.001-.036-.035-.032.035-2.076-2.12a8.29 8.29 0 00-11.881 0c-3.281 3.343-2.59 8.183 0 12.11 3.773 5.73 13.685 13.996 13.91 14.184l.004.003.043-.046.032.035.036-.035.043.046v-.001c.133-.11 10.122-8.429 13.914-14.185 2.59-3.928 3.281-8.768 0-12.112a8.29 8.29 0 00-11.881 0l-2.075 2.12zm.056 21.265l-.017.016-.09-.098-.216.232-.168-.146a139.275 139.275 0 01-3.833-3.468c-1.833-1.724-3.786-3.666-5.431-5.528h4.385l1.364-4.094L20 28.193l3.101-7.754 1.281 2.56h4.834c-1.545 1.708-3.314 3.459-4.984 5.029a139.275 139.275 0 01-3.832 3.468l-.168.146-.141-.15zM30.933 21h-5.315l-2.72-5.439L20 22.807l-4.085-10.213-2.636 7.906H8.673a22.75 22.75 0 01-.994-1.381c-2.35-3.567-2.563-7.247-.243-9.61a6.291 6.291 0 019.026-.001l3.556 3.632.49-.536 3.029-3.096a6.292 6.292 0 019.026 0c2.32 2.364 2.109 6.044-.242 9.61A24.89 24.89 0 0130.933 21z",
    fill: "#95A0B3"
  }));
};

exports.MealHealthyLinear = MealHealthyLinear;
var _default = MealHealthyLinear;
exports.default = _default;